module.exports = __webpack_public_path__ + "media/368fc6967e524103aad26f435df734b8.6fb86614.mp4";